import React from "react";
import { Link } from "react-router-dom";
import "../components/Header.css";

export default function Header() {
  return (
    <div>
      <header className="header">
        <div className="header_logo">
          <Link to="/" className="logo-link">
            dast.
          </Link>
        </div>

        <nav className="header_nav">
          <div className="dropdown">
            <button className="dropdown_button">Men</button>
            <div className="dropdown_menu">
              <Link to="/nike?gender=Men" className="dropdown_item">
                Nike
              </Link>
              <Link to="/macys?gender=Men" className="dropdown_item">
                Macys
              </Link>
              <Link to="/vineyardvines?gender=Men" className="dropdown_item">
                Vineyard Vines
              </Link>
              <Link to="/lacoste?gender=Men" className="dropdown_item">
                Lacoste
              </Link>
              <Link to="/zara?gender=Men" className="dropdown_item">
                Zara
              </Link>
            </div>
          </div>

          <div className="dropdown">
            <button className="dropdown_button">Women</button>
            <div className="dropdown_menu">
              <Link to="/nike?gender=Women" className="dropdown_item">
                Nike
              </Link>
              <Link to="/macys?gender=Women" className="dropdown_item">
                Macys
              </Link>
              <Link to="/vineyardvines?gender=Women" className="dropdown_item">
                Vineyard Vines
              </Link>
              <Link to="/lacoste?gender=Women" className="dropdown_item">
                Lacoste
              </Link>
              <Link to="/zara?gender=Women" className="dropdown_item">
                Zara
              </Link>
              <Link to="/ulta?gender=Women" className="dropdown_item">
                Ulta
              </Link>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
}
